import type { UserGroupsFormSchemaValues } from "../schemas/user-groups-form.schema";

export const USER_GROUPS_FORM_DEFAULT_VALUES: UserGroupsFormSchemaValues = {
  name: "",
  description: undefined,
  users: undefined,
  updatedAt: undefined,
};
